import styled from "styled-components";

export const NotificationPermissionPopup = styled.div`
  &#notificationPermissionPopup {
    z-index: 4;
    top: 0;
    border-radius: 0 0 8px 8px;
    line-height: 1.4;
    ${({ theme: { isDesktop } }) =>
      isDesktop &&
      `width:450px;
          right:0;
          left:0;
          box-shadow: rgb(51 51 51) 0 5px 10px -5px;
          `}
    .mobileShadow {
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.25);

      img {
        padding: 4px;
        box-shadow: 0 1px 4px rgba(0, 0, 0, 0.15);
      }
    }
  }
`;
